import React from "react";
import { NakiNigunHomeGridCellTemplate } from "themes/application/naki-nigun/components";

function NakiNigunHomeGridCell(props) {
    return <NakiNigunHomeGridCellTemplate {...props} />;
}

export default NakiNigunHomeGridCell;
